import script from "./CardSummarySingle.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSummarySingle.vue?vue&type=script&setup=true&lang=js"

import "./CardSummarySingle.vue?vue&type=style&index=0&id=5d67c8a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d67c8a6"]])

export default __exports__